// src/utils/profileDraft.js
const KEY = "PROFILE_DRAFT";

export const getProfileDraft = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
};

export const setProfileDraft = (partial) => {
  const current = getProfileDraft();
  const next = { ...current, ...partial };
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
};

export const clearProfileDraft = () => {
  localStorage.removeItem(KEY);
};
